module.exports = __webpack_public_path__ + "img/202412100101.35b685a1.png";